import { Injectable } from '@angular/core';
import MapView = require('esri/views/MapView');
import esriConfig = require('esri/config');
import GraphicsLayer = require('esri/layers/GraphicsLayer');
import MapImageLayer = require('esri/layers/MapImageLayer');

@Injectable()
export class MapService {
    view: MapView;
    selGraphics: GraphicsLayer;
    tempSelPlgGraphics: GraphicsLayer;
    tempSelGraphics: GraphicsLayer;
    currentDynamicLayers: Array<any> = [];
    currentCompPlanLayer:MapImageLayer;
    obliquePointGraphicLayer:GraphicsLayer;
    popupSelectedFeatureGraphicLayer:GraphicsLayer;
    applyGeometryQueryGraphic:GraphicsLayer;
    constructor() {
        esriConfig.request.useCors = true;
    }
}


// WEBPACK FOOTER //
// ./app/map-view/map.service.ts